<template>
  <!-- Affichage de la note -->
  <p v-if="!showForm && notes && notes.trim()" class="is-size-7 mb-0">
    <span class="has-white-space-pre-line">{{ notes }}</span>
  </p>
</template>

<script>
export default {
  props: {
    notes: String,
    showForm: Boolean
  }
}
</script>
